import React from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Grid } from '@material-ui/core';
import ProfileTitle from '../../layout/mobile/profile/ProfileTitle';
import { useReturnsStyles } from './styles';
import { stepsReturns } from './stepsReturns';
import { dvuelveFormPe } from '../../../config/paths';

const Returns = (props) => {
  const { mobile } = props;
  const classes = useReturnsStyles({ mobile });

  return (
    <Box className={classes.container}>
      <ProfileTitle mobile={mobile} title={<strong>Devoluciones</strong>} />

      <Grid className={classes.grid}>
        <div className={classes.containerGrid}>
          <h3 className={classes.title}>¿Cómo puedo devolver mi compra?</h3>
          <>
            <div className={classes.mainContainer}>
              {stepsReturns.map((steps) => (
                <React.Fragment key={steps.step}>
                  <div className={classes.stepsContainer}>
                    <div className={classes.titleContainer}>
                      <div className={classes.stepTitle}>{steps.step}</div>
                      <img src={steps.icon} className={classes.icon} />
                    </div>
                    <div className={classes.text}>{steps.text}</div>
                  </div>
                </React.Fragment>
              ))}
            </div>
          </>
        </div>

        <div className={classes.containerButton}>
          <Button
            onClick={() => window.open(dvuelveFormPe, '_blank')}
            className={classes.button}
            variant="contained"
            color="primary"
          >
            Inicia tu devolución
          </Button>
        </div>
      </Grid>
    </Box>
  );
};

Returns.propTypes = {
  mobile: PropTypes.bool,
};

export default Returns;
